import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import LoginLayout from 'layout/Auth/index';


// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const ReportDashboardDefault = Loadable(lazy(() => import('pages/dashboard/report_dashboard')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// render - users   
const UsersPage = Loadable(lazy(() => import('pages/auth/users')));
const UserViewPage = Loadable(lazy(() => import('pages/auth/user-view')));
const UserreportViewPage = Loadable(lazy(() => import('pages/auth/user-report')));
const UsernewreportViewPage = Loadable(lazy(() => import('pages/auth/user-new-report')));
const MaturityViewPage = Loadable(lazy(() => import('pages/auth/maturity')));
const EmailFilterViewPage = Loadable(lazy(() => import('pages/auth/email-maturity')));

const OldUsersViewPage = Loadable(lazy(() => import('pages/auth/old-users')));
const OldUsersingleViewPage = Loadable(lazy(() => import('pages/auth/old-usersingle-view')));
const OvelallUsersViewPage = Loadable(lazy(() => import('pages/auth/overallreport-report')));

const FiatPage = Loadable(lazy(() => import('pages/auth/fiatwithdraw')));

const KycPage = Loadable(lazy(() => import('pages/auth/kyc')));
const StakePage = Loadable(lazy(() => import('pages/auth/stake')));
const StakeReportPage = Loadable(lazy(() => import('pages/auth/stakereport')));
const KaitWalletPage = Loadable(lazy(() => import('pages/auth/kaitwallet')));
const IncomeWalletPage = Loadable(lazy(() => import('pages/auth/incomewallet')));
const RoswalletViewPage = Loadable(lazy(() => import('pages/auth/roswallet')));
const WithdrawReportViewPage = Loadable(lazy(() => import('pages/auth/withdraw-report')));
const LevelIncomeReportViewPage = Loadable(lazy(() => import('pages/auth/levelincome-report')));
const TransactionReportViewPage = Loadable(lazy(() => import('pages/auth/transaction-report')));
const StackOverAllReportViewPage = Loadable(lazy(() => import('pages/auth/stackoverall-report')));
const RestakeViewPage = Loadable(lazy(() => import('pages/auth/restake')));


const ComplaintsPage = Loadable(lazy(() => import('pages/auth/complaints')));
const ComplaintViewPage = Loadable(lazy(() => import('pages/auth/complaint-view')));
const ComplaintSingleViewPage = Loadable(lazy(() => import('pages/auth/complaint-single-view')));
const TicketPage = Loadable(lazy(() => import('pages/auth/ticket')));
const AdminPage = Loadable(lazy(() => import('pages/auth/admins')));
const WithdrawPage = Loadable(lazy(() => import('pages/auth/withdraw')));
const WithdrawpandingPage = Loadable(lazy(() => import('pages/auth/withdraw-pending')));


const ProfileViewPage = Loadable(lazy(() => import('pages/auth/profile-view')));



// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/dashboard',
      element: <DashboardDefault />
    },
    {
      path: 'userreport',
      element: <UserreportViewPage />
    },
    {
      path: 'usernewreport',
      element: <UsernewreportViewPage />
    },
    {
      path: 'maturity',
      element: <MaturityViewPage />
    },
    {
      path: 'email_Maturity',
      element: <EmailFilterViewPage />
    },
    {
      path: 'oldusers',
      element: <OldUsersViewPage />
    },
    {
      path: 'overallusers',
      element: <OvelallUsersViewPage />
    },
    {
      path: 'old_users/:id',
      element: <OldUsersingleViewPage />
    },
    {
      path: 'users',
      element: <UsersPage />
    },
    {
      path: 'users/:id',
      element: <UserViewPage />
    },
    {
      path: 'withdrawel',
      children: [

          {
            path: 'withdraw',
            element: <WithdrawPage />
          },
          {
            path: 'Withdarwpending',
            element: <WithdrawpandingPage />
          },
      ]
    },

   {
      path: 'fiatwithdraw',
      element: <FiatPage />
    },

     {
      path: 'admins',
      element: <AdminPage />
    },
    {
      path: 'complaints',
      children: [
        {
          path: '',
          element: <ComplaintsPage />
        },
        {
          path: 'list',
          element: <ComplaintViewPage />
        },
        {
          path: ':id',
          element: <ComplaintSingleViewPage />
        }
      ]
    },
    
     {
      path: 'kyc',
      element: <KycPage />
    },
    {
      path: 'stake',
      element: <StakePage />
    },
     {
      path: 'kaitwallet',
      element: <KaitWalletPage />
    },
     {
      path: 'incomewallet',
      element: <IncomeWalletPage />
    },
    {
      path: 'stakereport',
      element: <StakeReportPage />
    },
     {
      path: 'ticket',
      element: <TicketPage />
    },
    {
      path: 'profile',
      element: <ProfileViewPage />
    },
    {
      path: 'roswallet',
      element: <RoswalletViewPage />
    },
     {
      path: 'restake',
      element: <RestakeViewPage />
    },
     {
      path: 'withdrawreport',
      element: <WithdrawReportViewPage />
    },
    {
      path: 'levelincomereport',
      element: <LevelIncomeReportViewPage />
    },
    {
      path: 'Transactionreport',
      element: <TransactionReportViewPage />
    },
    {
      path: 'StackOverallreport',
      element: <StackOverAllReportViewPage />
    }
  ]   
};  

export default MainRoutes;